import React from 'react';
import { Link } from '@inertiajs/react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../utils/cn';

export const Breadcrumbs = React.forwardRef(function Breadcrumbs(
  { items, className },
  ref,
) {
  return (
    <nav ref={ref} aria-label="Breadcrumb" className={cn('mb-4', className)}>
      <ol className="flex items-center gap-1.5 text-sm">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-1.5">
              {i > 0 && (
                <ChevronRight size={14} className="text-fg-tertiary shrink-0" />
              )}
              {isLast ? (
                <span className="text-fg-secondary font-medium">{item.label}</span>
              ) : (
                <Link
                  href={item.href}
                  className="text-fg-tertiary hover:text-fg transition-colors"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
});
